// ==================================================================================== SECTION 1
// ========================================== SEARCH
let coSearchButton = document.querySelector('.co-blog-search-button');
coSearchButton.addEventListener('click', function(e) {
  e.preventDefault();
  setTimeout(function() {
      document.querySelector('.header__icon--search').click();
  }, 100);
});
// ========================================== FILTER
// POPUP
let coShopSection3OpenButton = document.querySelector('.co-blog-filter-button');
let coShopSection3CloseButton = document.querySelector('#co-main-blog-section-1-popup-close-button-id');
let coShopSection3 = document.querySelector('#co-main-blog-section-1-popup-id');
let coShopSection3Body = document.querySelector('body');
let coShopSection3Animate = document.querySelector('.co-main-blog-section-1-popup-animate');
coShopSection3OpenButton.addEventListener('click', function(e) {
  e.preventDefault();
  if (!coShopSection3.classList.contains('co-main-blog-section-1-popup-active')) {
    coShopSection3.classList.add('co-main-blog-section-1-popup-active');
  }
  if (!coShopSection3Body.classList.contains('co-overflow-hidden')) {
    coShopSection3Body.classList.add('co-overflow-hidden');
  }
  if (!coShopSection3OpenButton.classList.contains('co-active')) {
    setTimeout(function() {
      coShopSection3OpenButton.classList.add('co-active');
    }, 50);
  }
  if (!coShopSection3Animate.classList.contains('co-main-blog-section-1-popup-animate-active')) {
    setTimeout(function() {
      coShopSection3Animate.classList.add('co-main-blog-section-1-popup-animate-active');
    }, 50);
  }    
});
coShopSection3CloseButton.addEventListener('click', function(e) {
  e.preventDefault();
  if (coShopSection3.classList.contains('co-main-blog-section-1-popup-active')) {
    coShopSection3.classList.remove('co-main-blog-section-1-popup-active');
  }
  if (coShopSection3Body.classList.contains('co-overflow-hidden')) {
    coShopSection3Body.classList.remove('co-overflow-hidden');
  }
  if (coShopSection3OpenButton.classList.contains('co-active')) {
    coShopSection3OpenButton.classList.remove('co-active');
  }
  if (coShopSection3Animate.classList.contains('co-main-blog-section-1-popup-animate-active')) {
    setTimeout(function() {
      coShopSection3Animate.classList.remove('co-main-blog-section-1-popup-animate-active');
    }, 50);
  }    
});
// ========================================== GSAP
ScrollTrigger.create({
  // markers: true,
  trigger: 'body',
  start: "top top",
  end: "bottom bottom",
  pin: ".co-main-blog-section-1-popup-wrapper",
  pinSpacing: false,
}); 
// ==================================================================================== SECTION 1
// ENTRY
gsap.to('.co-main-blog-section-1-frame', { 
  opacity: 1, 
  duration: 1 
});
// ==================================================================================== SECTION 2
gsap.set('.co-main-blog-section-2-top-frame a', { opacity: 0, y: 40 });
gsap.to('.co-main-blog-section-2-top-frame a', {
  scrollTrigger: {
    trigger: ".co-main-blog-section-2-top",
    start: "top bottom",
    end: "bottom top",
  },
  opacity: 1,
  y: 0,
  duration: 0.75,
  ease: "power2.inOut",
  stagger: 0.1
});
gsap.set('.co-main-blog-section-2-bot-overlay', { opacity: 0 });
gsap.to('.co-main-blog-section-2-bot-overlay', {
  scrollTrigger: {
    trigger: ".co-main-blog-section-2-bot",
    start: "50% bottom",
    end: "bottom top",
  },
  opacity: 0.5,
  duration: 1,
  ease: "power2.inOut",
  stagger: 0.1
});
gsap.set('.co-main-blog-section-2-bot-content>*', { opacity: 0, y: 20 });
gsap.to('.co-main-blog-section-2-bot-content>*', {
  scrollTrigger: {
    trigger: ".co-main-blog-section-2-bot",
    start: "50% bottom",
    end: "bottom top",
  },
  opacity: 1,
  y: 0,
  duration: 1,
  ease: "power2.inOut",
  stagger: 0.1
});
// ========================================== SCRUB
gsap.set('.co-main-blog-section-2-bot-img-frame-2 img', { transition: 0, top: "-10%" });
gsap.to('.co-main-blog-section-2-bot-img-frame-2 img', {
  scrollTrigger: {
    trigger: ".co-main-blog-section-2-bot",
    start: "top bottom",
    end: "bottom top",
    scrub: 1
  },
  top: "0%"
});
// ==================================================================================== SECTION 3
// ========================================== ACCORDION REUSABLE FUNCTION
function createAccordionAnimation(
  containerSelector,
  groupSelector,
  menuSelector,
  contentSelector,
  openIconSelector,
  closeIconSelector,
  imageSelector, 
  toggleFirstMenu = false
) {
  let groups = gsap.utils.toArray(groupSelector, document.querySelector(containerSelector));
  let menus = gsap.utils.toArray(menuSelector, document.querySelector(containerSelector));
  let images = gsap.utils.toArray(imageSelector, document.querySelector(containerSelector));
  let menuToggles = groups.map(createAnimation);
  menus.forEach((menu) => {
    menu.addEventListener("click", () => toggleMenu(menu));
  });
  function toggleMenu(clickedMenu) {
    menuToggles.forEach((toggleFn) => toggleFn(clickedMenu));
  }
  function updateActiveImage(activeIndex) {
    images.forEach((img, index) => {
      img.classList.toggle('co-active', index === activeIndex);
    });
  }
  function createAnimation(element, index) {
    let menu = element.querySelector(menuSelector);
    let box = element.querySelector(contentSelector);
    let minusElement = element.querySelector(openIconSelector);
    let plusElement = element.querySelector(closeIconSelector);
    gsap.set(box, { height: "auto" });
    let animation = gsap
      .timeline()
      .from(box, {
        height: 0,
        duration: 0.3,
        ease: "power2.inOut"
      })
      .from(minusElement, { duration: 0.1, autoAlpha: 0, ease: "none" }, 0)
      .to(plusElement, { duration: 0.1, autoAlpha: 0, ease: "none" }, 0)
      .reverse();
    return function (clickedMenu) {
      if (clickedMenu === menu) {
        animation.reversed(!animation.reversed());
        if (!animation.reversed()) {
          updateActiveImage(index);
        }
      } else {
        animation.reverse();
      }
    };
  }
  if (toggleFirstMenu && menus.length > 0) {
    toggleMenu(menus[0]);
  }
}
// ========================================== ACCORDION FUNCTION
createAccordionAnimation(
  ".co-main-blog-section-3",       
  ".co-main-blog-section-3-accordion-group",
  ".co-main-blog-section-3-accordion-menu",  
  ".co-main-blog-section-3-accordion-content", 
  ".co-main-blog-section-3-accordion-open",   
  ".co-main-blog-section-3-accordion-close",
  ".co-main-blog-section-3-images",
  true
);
// ========================================== GSAP
gsap.set('.co-main-blog-section-3-frame', { opacity: 0 });
gsap.to('.co-main-blog-section-3-frame', {
  scrollTrigger: {
    trigger: ".co-main-blog-section-3-frame",
    start: "top bottom",
    end: "bottom top",
  },
  opacity: 1,
  duration: 1,
  ease: "power2.inOut"
});
// ==================================================================================== SECTION 4
gsap.set('.co-main-blog-section-4 .co-main-blog-section-grid-frame', { opacity: 0 });
gsap.to('.co-main-blog-section-4 .co-main-blog-section-grid-frame', {
  scrollTrigger: {
    trigger: ".co-main-blog-section-4 .co-main-blog-section-grid-frame",
    start: "top bottom",
    end: "bottom top",
  },
  opacity: 1,
  duration: 1,
  ease: "power2.inOut"
});
gsap.set('.co-main-blog-section-4 .co-main-blog-section-grid-grid>div', { opacity: 0 });
gsap.to('.co-main-blog-section-4 .co-main-blog-section-grid-grid>div', {
  scrollTrigger: {
    trigger: ".co-main-blog-section-4 .co-main-blog-section-grid-grid",
    start: "top bottom",
    end: "bottom top",
  },
  opacity: 1,
  duration: 1,
  ease: "power2.inOut",
  stagger: 0.075
});
// ==================================================================================== SECTION 5
gsap.set('.co-main-blog-section-5 .co-main-blog-section-grid-frame', { opacity: 0 });
gsap.to('.co-main-blog-section-5 .co-main-blog-section-grid-frame', {
  scrollTrigger: {
    trigger: ".co-main-blog-section-5 .co-main-blog-section-grid-frame",
    start: "top bottom",
    end: "bottom top",
  },
  opacity: 1,
  duration: 1,
  ease: "power2.inOut"
});
gsap.set('.co-main-blog-section-5 .co-main-blog-section-grid-grid>div', { opacity: 0 });
gsap.to('.co-main-blog-section-5 .co-main-blog-section-grid-grid>div', {
  scrollTrigger: {
    trigger: ".co-main-blog-section-5 .co-main-blog-section-grid-grid",
    start: "top bottom",
    end: "bottom top",
  },
  opacity: 1,
  duration: 1,
  ease: "power2.inOut",
  stagger: 0.075
});
// ==================================================================================== SECTION 6
// ========================================== ACCORDION FUNCTION
createAccordionAnimation(
  ".co-main-blog-section-6",       
  ".co-main-blog-section-6-accordion-group",
  ".co-main-blog-section-6-accordion-menu",  
  ".co-main-blog-section-6-accordion-content", 
  ".co-main-blog-section-6-accordion-open",   
  ".co-main-blog-section-6-accordion-close",
  ".co-main-blog-section-6-images",
  true
);
// ========================================== GSAP
gsap.set('.co-main-blog-section-6-frame', { opacity: 0 });
gsap.to('.co-main-blog-section-6-frame', {
  scrollTrigger: {
    trigger: ".co-main-blog-section-6-frame",
    start: "top bottom",
    end: "bottom top",
  },
  opacity: 1,
  duration: 1,
  ease: "power2.inOut"
});




